import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { TrendingUp } from "lucide-react";
import { CHART, ChartCard, ChartEmpty, Dot, TooltipBox, axisTick } from "./ui";

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload || payload.length === 0) return null;
  const data = payload[0]?.payload || {};
  return (
    <TooltipBox title={data.dateLabel || label}>
      <span className="flex items-center gap-1.5"><Dot color={CHART.primary} />Answer Rate: {(data.rate || 0).toFixed(1)}%</span>
      <span>{data.answered || 0} / {data.total_queries || 0} answered</span>
    </TooltipBox>
  );
};

const AnswerRateChart = ({ daily }: any) => {
  const card = (body) => (
    <ChartCard icon={<TrendingUp />} title="Answer Rate Trend" description="Share of guest questions your chatbot answered each day.">
      {body}
    </ChartCard>
  );
  if (!daily || daily.length === 0) {
    return card(<ChartEmpty icon={<TrendingUp />} text="No performance data for selected period" />);
  }

  const chartData = daily.map((d) => ({
    ...d,
    rate: d.total_queries ? (d.answered / d.total_queries) * 100 : 0,
    dateLabel: d.date
      ? new Date(d.date + "T00:00:00").toLocaleDateString("en-GB", { day: "numeric", month: "short" })
      : "",
  }));

  return card(
    <ResponsiveContainer width="100%" height={280}>
      <AreaChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 5 }}>
        <defs>
          <linearGradient id="answerRateGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={CHART.primary} stopOpacity={0.25} />
            <stop offset="95%" stopColor={CHART.primary} stopOpacity={0.02} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke={CHART.grid} vertical={false} />
        <XAxis dataKey="dateLabel" tick={axisTick} tickLine={false} axisLine={{ stroke: CHART.grid }} />
        <YAxis domain={[0, 100]} tick={axisTick} tickLine={false} axisLine={false} tickFormatter={(v) => `${v}%`} />
        <Tooltip content={<CustomTooltip />} />
        <Area
          type="monotone"
          dataKey="rate"
          name="Answer Rate"
          stroke={CHART.primary}
          strokeWidth={2}
          fill="url(#answerRateGradient)"
          dot={{ r: 4, fill: CHART.primary, stroke: CHART.surface, strokeWidth: 2 }}
          activeDot={{ r: 6, fill: CHART.primary, stroke: CHART.surface, strokeWidth: 2 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default AnswerRateChart;
